(function () {
  "use strict";

  var BODY_FONT =
    'var(--font-body-family, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif)';

  function forceKaktusfFonts(root) {
    if (!root) return;
    var DISPLAY = 'Oswald, "Fjalla One", Impact, sans-serif';
    root.querySelectorAll(".kaktusf-product__title, .kaktusf-prod-title").forEach(function (el) {
      el.style.setProperty("font-family", DISPLAY, "important");
      el.style.setProperty("letter-spacing", "0.02em", "important");
      el.style.setProperty("text-transform", "none", "important");
      el.style.setProperty("font-size", "18px", "important");
      el.style.setProperty("line-height", "1.2", "important");
      el.style.setProperty("font-weight", "700", "important");
      el.style.setProperty("color", "#2e3843", "important");
      el.style.setProperty("display", "-webkit-box", "important");
      el.style.setProperty("-webkit-box-orient", "vertical", "important");
      el.style.setProperty("-webkit-line-clamp", "2", "important");
      el.style.setProperty("overflow", "hidden", "important");
      el.style.setProperty("white-space", "normal", "important");
      el.style.setProperty("max-width", "100%", "important");
      el.style.setProperty("background", "transparent", "important");
    });
    root.querySelectorAll(".kaktusf-popup__title, .kaktusf-title, .kaktusf-popup__heading").forEach(function (el) {
      el.style.setProperty("font-family", DISPLAY, "important");
      el.style.setProperty("font-size", "28px", "important");
      el.style.setProperty("font-weight", "700", "important");
      el.style.setProperty("color", "#fff", "important");
      el.style.setProperty("text-transform", "none", "important");
      el.style.setProperty("text-align", "center", "important");
      el.style.setProperty("letter-spacing", "0.04em", "important");
      el.style.setProperty("background", "transparent", "important");
      el.style.setProperty("width", "100%", "important");
    });
    root.querySelectorAll(".kaktusf-save-label").forEach(function (el) {
      el.style.setProperty("line-height", "1.15", "important");
      el.style.setProperty("font-size", "12px", "important");
      el.style.setProperty("font-family", DISPLAY, "important");
      el.style.setProperty("font-style", "normal", "important");
      el.style.setProperty("padding", "4px 6px", "important");
      el.style.setProperty("display", "inline-block", "important");
      el.style.setProperty("max-height", "none", "important");
      el.style.setProperty("position", "relative", "important");
      el.style.setProperty("background", "#e10600", "important");
      el.style.setProperty("color", "#fff", "important");
    });
    var narrow = window.matchMedia("(max-width: 749px)").matches;
    var tw = narrow ? "110px" : "140px";
    var th = narrow ? "72px" : "90px";
    var titleFs = narrow ? "15px" : "18px";
    var priceFs = narrow ? "20px" : "24px";
    root.querySelectorAll(".kaktusf-product__title, .kaktusf-prod-title").forEach(function (el) {
      el.style.setProperty("font-size", titleFs, "important");
    });
    root.querySelectorAll(".kaktusf-product--img, .kaktusf-product__img img").forEach(function (el) {
      el.style.setProperty("width", tw, "important");
      el.style.setProperty("height", th, "important");
      el.style.setProperty("object-fit", "contain", "important");
      el.style.setProperty("background", "#000", "important");
    });
    root.querySelectorAll(".kaktusf-price--main, .kaktusf-price").forEach(function (el) {
      if (el.closest && el.closest(".kaktusf-product__price")) {
        el.style.setProperty("font-size", priceFs, "important");
      }
    });
    root.querySelectorAll(".kaktusf-total-price").forEach(function (el) {
      el.style.setProperty("visibility", "visible", "important");
      el.style.setProperty("display", "inline-block", "important");
      el.style.setProperty("font-size", "18px", "important");
      el.style.setProperty("color", "#2e3843", "important");
    });
    repairKaktusfRows(root);
  }

  function repairKaktusfRows(root) {
    if (!root) return;
    var DISPLAY = 'Oswald, "Fjalla One", Impact, sans-serif';
    root.querySelectorAll(".kaktusf-product__item").forEach(function (item) {
      item.style.setProperty("display", "flex", "important");
      item.style.setProperty("flex-direction", "row", "important");
      item.style.setProperty("align-items", "center", "important");
      item.style.setProperty("position", "relative", "important");
      item.style.setProperty("background", "#ffffff", "important");
      item.style.setProperty("overflow", "visible", "important");
      item.style.setProperty("margin", "36px 0 0", "important");
      item.style.setProperty("padding", "0 12px 0 0", "important");
      item.style.setProperty("border-radius", "0", "important");
      item.style.setProperty("width", "100%", "important");
      item.style.setProperty("max-width", "100%", "important");
      item.style.setProperty("box-sizing", "border-box", "important");

      var icon = item.querySelector(".kaktusf-bundle-icon");
      if (icon) {
        icon.style.setProperty("position", "absolute", "important");
        icon.style.setProperty("left", "0", "important");
        icon.style.setProperty("right", "0", "important");
        icon.style.setProperty("top", "-28px", "important");
        icon.style.setProperty("width", "100%", "important");
        icon.style.setProperty("height", "22px", "important");
        icon.style.setProperty("flex", "0 0 auto", "important");
        icon.style.setProperty("display", "flex", "important");
        icon.style.setProperty("align-items", "center", "important");
        icon.style.setProperty("justify-content", "center", "important");
        icon.style.setProperty("background", "transparent", "important");
        icon.style.setProperty("z-index", "5", "important");
        var inner = icon.querySelector("div");
        if (inner) {
          inner.style.setProperty("width", "22px", "important");
          inner.style.setProperty("height", "22px", "important");
          inner.style.setProperty("border-radius", "50%", "important");
          inner.style.setProperty("background", "#637381", "important");
          inner.style.setProperty("color", "#111", "important");
          inner.style.setProperty("display", "flex", "important");
          inner.style.setProperty("align-items", "center", "important");
          inner.style.setProperty("justify-content", "center", "important");
          inner.style.setProperty("font-size", "16px", "important");
          inner.style.setProperty("font-weight", "700", "important");
          inner.style.setProperty("line-height", "22px", "important");
          inner.style.setProperty("z-index", "2", "important");
          if (!inner.textContent || !inner.textContent.trim()) inner.textContent = "+";
        }
      }

      var wrap = item.querySelector(".kaktusf-bundle-product-wrap");
      if (wrap) {
        wrap.style.setProperty("flex", "1 1 auto", "important");
        wrap.style.setProperty("min-width", "0", "important");
        wrap.style.setProperty("width", "auto", "important");
        wrap.style.setProperty("max-width", "none", "important");
        wrap.style.setProperty("margin", "0", "important");
        wrap.style.setProperty("position", "relative", "important");
        wrap.style.setProperty("left", "auto", "important");
        wrap.style.setProperty("background", "transparent", "important");
      }

      var active = item.querySelector(".kaktusf-active-product");
      if (active) {
        active.style.setProperty("position", "relative", "important");
        active.style.setProperty("flex", "0 0 36px", "important");
        active.style.setProperty("margin", "0 0 0 -10px", "important");
        active.style.setProperty("z-index", "4", "important");
        active.style.setProperty("background", "transparent", "important");
        if (item.firstElementChild !== active) {
          item.insertBefore(active, item.firstElementChild);
        }
      }
      var check = item.querySelector(".kaktusf-check");
      if (check) {
        check.style.setProperty("width", "26px", "important");
        check.style.setProperty("height", "26px", "important");
        check.style.setProperty("background", "#fff", "important");
        check.style.setProperty("border", "1px solid #c5c5c5", "important");
        check.style.setProperty("border-radius", "2px", "important");
        check.style.setProperty("box-shadow", "0 0 0 1px rgba(0,0,0,.08)", "important");
      }

      var imgWrap = item.querySelector(".kaktusf-product__img");
      var saveBox = item.querySelector(".kaktusf-price--compare");
      if (imgWrap) {
        var narrow2 = window.matchMedia("(max-width: 749px)").matches;
        var iw = narrow2 ? "110px" : "140px";
        var ih = narrow2 ? "72px" : "90px";
        imgWrap.style.setProperty("position", "relative", "important");
        imgWrap.style.setProperty("flex", "0 0 " + iw, "important");
        imgWrap.style.setProperty("width", iw, "important");
        imgWrap.style.setProperty("height", ih, "important");
        imgWrap.style.setProperty("background", "#000", "important");
        imgWrap.style.setProperty("overflow", "visible", "important");
      }
      if (imgWrap && saveBox && saveBox.parentElement !== imgWrap) {
        imgWrap.appendChild(saveBox);
        saveBox.style.setProperty("position", "absolute", "important");
        saveBox.style.setProperty("left", "0", "important");
        saveBox.style.setProperty("top", "0", "important");
        saveBox.style.setProperty("z-index", "6", "important");
        saveBox.style.setProperty("background", "transparent", "important");
      }

      var price = item.querySelector(".kaktusf-product__price");
      if (price) {
        price.style.setProperty("position", "relative", "important");
        price.style.setProperty("left", "auto", "important");
        price.style.setProperty("flex", "0 0 auto", "important");
        price.style.setProperty("color", "#2e3843", "important");
        price.style.setProperty("background", "transparent", "important");
        price.style.setProperty("overflow", "visible", "important");
        price.style.setProperty("display", "flex", "important");
        price.style.setProperty("flex-direction", "column", "important");
        price.style.setProperty("align-items", "flex-end", "important");
        price.querySelectorAll(".kaktusf-price--main, .kaktusf-price").forEach(function (n) {
          n.style.setProperty("background", "transparent", "important");
          n.style.setProperty("color", "#2e3843", "important");
          n.style.setProperty("font-family", DISPLAY, "important");
          n.style.setProperty("font-size", window.matchMedia("(max-width: 749px)").matches ? "20px" : "24px", "important");
          n.style.setProperty("font-weight", "700", "important");
          n.style.setProperty("line-height", "1.1", "important");
        });
        price.querySelectorAll(".kaktusf-price--compare-price, .kaktusf-compare-price, s").forEach(function (n) {
          n.style.setProperty("background", "transparent", "important");
          n.style.setProperty("color", "#858585", "important");
          n.style.setProperty("font-size", "13px", "important");
          n.style.setProperty("font-weight", "400", "important");
          n.style.setProperty("text-decoration", "line-through", "important");
          n.style.setProperty("order", "-1", "important");
        });
      }
      item.querySelectorAll("select").forEach(function (sel) {
        sel.style.setProperty("background", "#fff", "important");
        sel.style.setProperty("color", "#2e3843", "important");
        sel.style.setProperty("border", "1px solid #c5c5c5", "important");
      });
    });
  }

function polishAllKaktusf() {
    document.querySelectorAll("#kaktusf-app, .kaktusf-inline, .kaktusf-popup__body").forEach(forceKaktusfFonts);
  }

  function stripHtml(html) {
    var d = document.createElement("div");
    d.innerHTML = html || "";
    return (d.textContent || d.innerText || "").replace(/\s+/g, " ").trim();
  }

  function buildWaiverUI(fullHtml, existingCb) {
    var wrap = document.createElement("div");
    wrap.className = "wr-waiver";
    wrap.setAttribute("data-wr-waiver", "1");

    var row = document.createElement("div");
    row.className = "wr-waiver__row";

    var cb;
    if (existingCb) {
      cb = existingCb;
      cb.classList.add("wr-waiver__cb");
    } else {
      cb = document.createElement("input");
      cb.type = "checkbox";
      cb.id = "effectiveAppsAgreeCB";
      cb.className = "wr-waiver__cb";
      cb.checked = true;
      cb.setAttribute("onchange", "typeof termsAndConditionsCheckboxChanged==='function'&&termsAndConditionsCheckboxChanged(this);");
    }

    var label = document.createElement("label");
    label.className = "wr-waiver__label";
    label.htmlFor = "effectiveAppsAgreeCB";
    label.textContent = "I agree to the Racing/Competition use waiver";

    var toggle = document.createElement("button");
    toggle.type = "button";
    toggle.className = "wr-waiver__more";
    toggle.textContent = "Read waiver";

    var full = document.createElement("div");
    full.className = "wr-waiver__full";
    full.hidden = true;
    full.innerHTML = fullHtml || "";

    toggle.addEventListener("click", function () {
      var open = full.hidden;
      full.hidden = !open;
      toggle.textContent = open ? "Hide waiver" : "Read waiver";
    });

    row.appendChild(cb);
    row.appendChild(label);
    row.appendChild(toggle);
    wrap.appendChild(row);
    wrap.appendChild(full);
    return wrap;
  }

  function collapseWaiver() {
    if (document.querySelector("[data-wr-waiver='1']")) return;

    var tac = window.EFFECTIVE_APPS_TAC_TEXT;
    var existing = document.getElementById("effectiveAppsAgreeCB");

    // Reshape existing TAC injection
    if (existing && existing.closest("p,div,label")) {
      var host = existing.parentElement;
      if (host && !host.closest("[data-wr-waiver]")) {
        var ui = buildWaiverUI(tac || host.innerHTML, existing);
        host.replaceWith(ui);
        return;
      }
    }

    // Inject collapsed waiver before ATC if TAC text exists but checkbox missing
    if (!tac || existing) return;
    var btn =
      document.querySelector(".product-form__submit") ||
      document.querySelector("product-form button[type='submit']") ||
      document.querySelector("form[action*='/cart/add'] button[type='submit']");
    if (!btn) return;
    var anchor = btn.closest(".product-form__buttons") || btn.parentElement;
    if (!anchor) return;
    var ui2 = buildWaiverUI(tac, null);
    anchor.parentNode.insertBefore(ui2, anchor);
  }

  function run() {
    polishAllKaktusf();
    collapseWaiver();
  }

  var t;
  function schedule() {
    clearTimeout(t);
    t = setTimeout(run, 150);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule);
  else schedule();
  window.addEventListener("load", schedule);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initTechSupportModal(document); });
  } else {
    initTechSupportModal(document);
  }
  document.addEventListener("shopify:section:load", schedule);

  // Re-apply when KaktusF / TAC injects late
  try {
    var mo = new MutationObserver(schedule);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  function buildPdpColumns() {
    var info = document.querySelector(".product.wr-pdp .wr-pdp-info, .product.wr-pdp .product__info-container");
    if (!info || info.getAttribute("data-wr-cols") === "1") return;
    info.setAttribute("data-wr-cols", "1");

    var left = document.createElement("div");
    left.className = "wr-pdp-col wr-pdp-col--info";
    var right = document.createElement("div");
    right.className = "wr-pdp-col wr-pdp-col--buy";

    function isBuyNode(el) {
      if (!el || el.nodeType !== 1) return false;
      if (el.matches(".product__title, .product__description, .product__tax, .product__sku, .product__text, .product__inventory, .product__accordion, .rating-wrapper, share-button, .share-button, .volume-pricing-note, .product__view-details")) {
        return false;
      }
      if (el.matches(".wr-install-instructions, .wr-tech-support, [data-wr-tech-support]")) return true;
      if (el.id && el.id.indexOf("price-") === 0) return false;
      if (el.matches("variant-selects, .product-form__quantity, product-form, .product-form, #kaktusf-app, .kaktusf-inline, .wr-waiver, [data-wr-waiver], .shopify-app-block")) {
        return true;
      }
      if (el.id === "kaktusf-app") return true;
      if (el.querySelector && el.querySelector(".product-form__submit, .shopify-payment-button, variant-selects, .product-form__quantity, #effectiveAppsAgreeCB")) {
        // avoid pulling description wrappers
        if (el.matches(".product__description, .product__title")) return false;
        return true;
      }
      if (el.matches("p") && el.querySelector && el.querySelector("#effectiveAppsAgreeCB")) return true;
      return false;
    }

    var nodes = Array.prototype.slice.call(info.childNodes);
    nodes.forEach(function (node) {
      if (node.nodeType === 3 && !(node.textContent || "").trim()) return;
      if (node.nodeType === 1 && (node.tagName === "SCRIPT" || node.tagName === "STYLE" || node.tagName === "TEMPLATE")) {
        right.appendChild(node);
        return;
      }
      if (node.nodeType === 1 && isBuyNode(node)) {
        right.appendChild(node);
      } else {
        left.appendChild(node);
      }
    });

    info.appendChild(left);
    info.appendChild(right);
  }


  window.initTechSupportModal = initTechSupportModal;
  function initTechSupportModal(root) {
    var scope = root || document;
    // Modal may be sibling of CTA (not nested) — pair each open button with nearest modal
    scope.querySelectorAll("[data-wr-tech-open]").forEach(function (openBtn) {
      if (openBtn.dataset.wrTechBound === "1") return;
      openBtn.dataset.wrTechBound = "1";
      var wrap = openBtn.closest("[data-wr-tech-support]") || openBtn.parentElement;
      var modal =
        (wrap && wrap.parentElement && wrap.parentElement.querySelector("[data-wr-tech-modal]")) ||
        document.querySelector("[data-wr-tech-modal]");
      if (!modal) return;
      var scrollY = 0;
      function open() {
        // Portal to <body> so position:fixed is not trapped by PDP overflow/transform
        if (modal.parentElement !== document.body) document.body.appendChild(modal);
        modal.hidden = false;
        modal.classList.add("is-open");
        document.documentElement.classList.add("wr-tech-modal-open");
        document.body.classList.add("wr-tech-modal-open");
        scrollY = window.scrollY || 0;
        document.body.style.top = "-" + scrollY + "px";
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        document.documentElement.style.overflow = "hidden";
        var focusEl = modal.querySelector("[data-wr-tech-success], .wr-tech-modal__x, input");
        if (focusEl && focusEl.focus) try { focusEl.focus(); } catch (e) {}
      }
      function close() {
        modal.hidden = true;
        modal.classList.remove("is-open");
        document.documentElement.classList.remove("wr-tech-modal-open");
        document.body.classList.remove("wr-tech-modal-open");
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        document.documentElement.style.overflow = "";
        window.scrollTo(0, scrollY);
        openBtn.focus();
      }
      openBtn.addEventListener("click", function (e) {
        e.preventDefault();
        open();
      });
      modal.querySelectorAll("[data-wr-tech-close]").forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          close();
        });
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && !modal.hidden) close();
      });
      if (modal.querySelector("[data-wr-tech-success]")) open();
    });
  }
  function placeBuyColumnApps() {
    buildPdpColumns();
    var right = document.querySelector(".product.wr-pdp .wr-pdp-col--buy");
    if (!right) return;
    // ONLY move top-level KaktusF shells — never [id^=kaktusf-] internals (that destroyed the bundle)
    var shells = [];
    var app = document.getElementById("kaktusf-app");
    if (app) shells.push(app);
    document.querySelectorAll(".kaktusf-inline").forEach(function (el) {
      if (shells.indexOf(el) === -1 && !(app && app.contains(el))) shells.push(el);
    });
    shells.forEach(function (el) {
      if (el.closest && el.closest(".kaktusf-popup")) return;
      if (el.parentElement !== right) right.appendChild(el);
    });
    placeInstallBesideQty(right);
    placeTechSupportCta(right);
    var waivers = document.querySelectorAll(".wr-waiver, [data-wr-waiver], p:has(> #effectiveAppsAgreeCB)");
    var anchor = right.querySelector(".kaktusf-inline") || right.querySelector("#kaktusf-app");
    waivers.forEach(function (el) {
      if (anchor) anchor.insertAdjacentElement("afterend", el);
      else right.appendChild(el);
    });
  }


  function placeTechSupportCta(right) {
    var cta =
      document.querySelector("[data-wr-tech-support]") ||
      (right && right.querySelector("[data-wr-tech-support]"));
    if (!cta || !right) return;
    // Keep modal sibling (if any) out of the buy-col flow; it will portal to body on open
    var modalSibling = null;
    if (cta.nextElementSibling && cta.nextElementSibling.matches && cta.nextElementSibling.matches("[data-wr-tech-modal]")) {
      modalSibling = cta.nextElementSibling;
    }
    // Insert AFTER ATC / Shop Pay block
    var pay = right.querySelector(".shopify-payment-button");
    var form =
      right.querySelector("product-form") ||
      right.querySelector(".product-form");
    var anchor = null;
    if (pay) {
      anchor = pay.closest(".shopify-payment-button, div, product-form") || pay;
      // climb to the outermost buy-block child of right that contains pay
      var n = pay;
      while (n && n.parentElement !== right) n = n.parentElement;
      if (n && n.parentElement === right) anchor = n;
    } else if (form) {
      var n2 = form;
      while (n2 && n2.parentElement !== right) n2 = n2.parentElement;
      anchor = n2 || form;
    }
    if (anchor && anchor.parentElement === right) {
      if (anchor.nextSibling !== cta) {
        right.insertBefore(cta, anchor.nextSibling);
      }
    } else if (cta.parentElement !== right) {
      right.appendChild(cta);
    }
    // Bundle after tech CTA
    var bundle = right.querySelector(".kaktusf-inline, #kaktusf-app");
    if (bundle && bundle !== cta && cta.nextElementSibling !== bundle) {
      right.insertBefore(bundle, cta.nextSibling);
    }
    // Park modal under body early so it never participates in flex order
    if (modalSibling && modalSibling.parentElement !== document.body) {
      document.body.appendChild(modalSibling);
    } else {
      var orphanModal = document.querySelector(".product [data-wr-tech-modal], .wr-pdp-info [data-wr-tech-modal]");
      if (orphanModal && orphanModal.parentElement !== document.body) document.body.appendChild(orphanModal);
    }
  }
  function placeInstallBesideQty(right) {
    var install =
      document.querySelector(".wr-install-instructions") ||
      right.querySelector(".wr-install-instructions");
    if (!install) return;
    if (install.parentElement !== right && !install.closest(".wr-pdp-col--buy")) {
      right.appendChild(install);
    }
    var qty = right.querySelector(".product-form__quantity");
    if (!qty) return;
    var row = right.querySelector(".wr-pdp-qty-row");
    if (!row) {
      row = document.createElement("div");
      row.className = "wr-pdp-qty-row";
      qty.parentNode.insertBefore(row, qty);
      row.appendChild(qty);
    } else if (!row.contains(qty)) {
      row.appendChild(qty);
    }
    if (!row.contains(install)) row.appendChild(install);
    // Keep row above buy buttons / form
    var form =
      right.querySelector("product-form") ||
      right.querySelector(".product-form") ||
      right.querySelector("div:has(> .product-form__submit), div:has(.shopify-payment-button)");
    if (form && row.nextElementSibling !== form) {
      right.insertBefore(row, form);
    }
  }

  // Gallery: CSS owns hide/show (.is-active). JS must NOT MutationObserve class
  // changes while writing styles — that caused the Celica main-thread freeze.
  var wrGallerySyncing = false;
  var wrGalleryTimer = null;

  function syncGallerySlides(root) {
    if (wrGallerySyncing) return;
    var g = root || document.querySelector(".product.wr-pdp media-gallery");
    if (!g) return;
    wrGallerySyncing = true;
    try {
      if (!g.classList.contains("wr-pdp-gallery")) g.classList.add("wr-pdp-gallery");
      // Clear any leftover inline styles from older builds that caused overflow (left:-9999px)
      g.querySelectorAll(".product__media-item").forEach(function (li) {
        li.style.removeProperty("left");
        li.style.removeProperty("width");
        li.style.removeProperty("height");
        li.style.removeProperty("max-height");
        li.style.removeProperty("max-width");
        li.style.removeProperty("position");
        li.style.removeProperty("inset");
        li.style.removeProperty("display");
        li.style.removeProperty("visibility");
        li.style.removeProperty("opacity");
        li.style.removeProperty("pointer-events");
        li.style.removeProperty("overflow");
      });
    } finally {
      wrGallerySyncing = false;
    }
  }

  function scheduleGallerySync(g) {
    if (wrGalleryTimer) clearTimeout(wrGalleryTimer);
    wrGalleryTimer = setTimeout(function () {
      wrGalleryTimer = null;
      syncGallerySlides(g);
    }, 30);
  }

  function enhanceGallery() {
    var g = document.querySelector(".product.wr-pdp media-gallery");
    if (!g) return;
    if (g.dataset.wrGalleryBound === "1") return;
    g.dataset.wrGalleryBound = "1";
    syncGallerySlides(g);
    // After Dawn toggles .is-active on thumb click, CSS applies. One light cleanup only.
    g.addEventListener("click", function (ev) {
      var t = ev.target && ev.target.closest && ev.target.closest(".thumbnail, .thumbnail-list__item");
      if (!t) return;
      scheduleGallerySync(g);
    }, true);
    document.addEventListener("change", function (ev) {
      if (!ev.target || !ev.target.closest) return;
      if (ev.target.closest("variant-selects, variant-radios")) scheduleGallerySync(g);
    });
    // NO MutationObserver on gallery — it re-entered via class/aria updates and froze the page.
  }



  var wrPdpBooting = false;
  function bootPdpLayout() {
    if (wrPdpBooting) return;
    wrPdpBooting = true;
    try {
      placeBuyColumnApps();
      enhanceGallery();
      polishAllKaktusf();
    } catch (e) {}
    wrPdpBooting = false;
  }
  bootPdpLayout();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootPdpLayout);
  }
  setTimeout(bootPdpLayout, 500);
  setTimeout(bootPdpLayout, 1500);
  setTimeout(bootPdpLayout, 3000);
  // Only react to app injections, not our own moves
  if (typeof MutationObserver !== "undefined") {
    var scheduled = null;
    var mo = new MutationObserver(function (mutations) {
      if (wrPdpBooting) return;
      var interesting = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType !== 1) continue;
            if (n.id === "kaktusf-app" || (n.classList && (n.classList.contains("kaktusf-inline") || n.classList.contains("wr-waiver"))) || (n.querySelector && n.querySelector("#kaktusf-app, .kaktusf-inline, #effectiveAppsAgreeCB"))) {
              interesting = true;
              break;
            }
          }
        }
        if (interesting) break;
      }
      if (!interesting) return;
      if (scheduled) clearTimeout(scheduled);
      scheduled = setTimeout(function () {
        scheduled = null;
        bootPdpLayout();
      }, 100);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
